module.exports = __webpack_public_path__ + "img/01.9385095e.png";